<footer class="footer">
  <div class="container">
    <div class="columns">
      <div class="column">
        <nav class="level mb-4">
          <div class="level-left level-logos">
            <div class="level-item">
              <img
                src="./assets/images/logooecd_en.png"
                width="138"
                alt="OECD Logo"
              />
            </div>
            <div class="level-item is-hidden-touch">
              <div class="vertical-separator"></div>
            </div>
            <div class="level-item">
              <img
                src="./assets/images/flag-europe.svg"
                alt="EU Logo"
                style="height: 60px"
              />
            </div>
            <div class="level-item is-hidden-touch">
              <div class="vertical-separator"></div>
            </div>
            <div class="level-item">
              <div class="host">
                <span class="mr-2 is-size-8 mb-0">Hosted by:</span>
                <a href="https://stip.oecd.org/" target="_blank">
                  <img
                    src="./assets/images/stip-logo.svg"
                    alt="Stip Logo"
                    style="height: 50px"
                  />
                </a>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <a
                href="https://www.facebook.com/theOECD/"
                target="_blank"
                class="has-text-dark"
              >
                <i class="fa-brands fa-facebook-f"></i>
              </a>
            </div>
            <div class="level-item">
              <a
                href="https://twitter.com/OECDinnovation"
                target="_blank"
                class="has-text-dark"
              >
                <i class="fa-brands fa-twitter"></i>
              </a>
            </div>
            <div class="level-item">
              <a
                href="https://www.linkedin.com/company/oecd-ai"
                target="_blank"
                class="has-text-dark"
              >
                <i class="fa-brands fa-linkedin"></i>
              </a>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
  <div class="has-background-grey-lighter">
    <div class="container">
      <div class="columns">
        <div class="column">
          <nav class="level is-flex content is-small pb-4">
            <div class="level-left">
              <div class="level-item">
                © {{ currentYear }} OECD. All rights reserved
              </div>
            </div>
            <div class="level-right">
              <div class="level-item">
                <a
                  href="https://www.oecd.org/termsandconditions/"
                  target="_blank"
                  class="has-text-dark no-deco"
                  >Terms & conditions</a
                >
              </div>
              <div class="level-item">
                <a
                  href="https://www.oecd.org/privacy/"
                  target="_blank"
                  class="has-text-dark no-deco"
                  >Privacy policy</a
                >
              </div>
              <div class="level-item">
                <a
                  href="mailto:RDTaxStatsContact@oecd.org?subject=Contact%20INNOTAX%20portal"
                  class="has-text-dark no-deco"
                  >Contact us</a
                >
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</footer>
